import AssignmentStatusBadge from "./AssignmentStatusBadge";
import { formatAssignmentDate } from "../utils/assignmentUtils";

const AssignmentCard = ({ item }) => {
    const studentName = `${item.student.firstName} ${item.student.lastName}`.trim() || "Student";

    return (
        <article className="assignment-card">
            <header>
                <div>
                    <h3>{item.readingContent.title}</h3>
                    <p>
                        {studentName} {item.student.grade ? `• Grade ${item.student.grade}` : ""}
                    </p>
                </div>
                <AssignmentStatusBadge status={item.status} />
            </header>

            <dl className="assignment-facts">
                <div>
                    <dt>Student Code</dt>
                    <dd>{item.student.studentCode || "N/A"}</dd>
                </div>
                <div>
                    <dt>Level</dt>
                    <dd>{item.readingContent.level || "A"}</dd>
                </div>
                <div>
                    <dt>Due Date</dt>
                    <dd>{formatAssignmentDate(item.dueDate)}</dd>
                </div>
                <div>
                    <dt>Repetition</dt>
                    <dd>{item.repetitionCount}</dd>
                </div>
                <div>
                    <dt>AI Mode</dt>
                    <dd>{item.aiMode ? "On" : "Off"}</dd>
                </div>
                <div>
                    <dt>Created</dt>
                    <dd>{formatAssignmentDate(item.createdAt)}</dd>
                </div>
            </dl>
        </article>
    );
};

export default AssignmentCard;
